import { apiSlice } from '../apiSlice';
import { User } from '../../types/User';

const endpointUrl = '/users';

export const initialState: User = {
  id: '',
  userName: '',
  firstName: '',
  lastName: '',
  enabled: true,
  emailVerified: true,
  group: 'operation',
  agency: 'null'
};

function getUsers() {
  return `${endpointUrl}`;
}

function getUser({ id }: { id: string }) {
  return `${endpointUrl}/${id}`;
}

function updatePassword({ id, value }: { id: string; value: string }) {
  return {
    url: `${endpointUrl}/${id}/password`,
    method: 'PATCH',
    body: { value }
  };
}

function createUser({
  userName,
  firstName,
  lastName,
  group,
  agency,
  temporaryPassword,
  emailVerified = true
}: {
  userName: string;
  firstName: string;
  lastName: string;
  group: 'admin' | 'department' | 'recruiter' | 'operation';
  agency: string;
  temporaryPassword: string;
  emailVerified?: boolean;
}) {
  return {
    url: `${endpointUrl}`,
    method: 'POST',
    body: {
      userName,
      firstName,
      lastName,
      emailVerified,
      email: userName,
      temporaryPassword,
      admin: group == 'admin' ? true : false,
      group,
      agency
    }
  };
}

function deleteUser({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}

function blockUser({ id, enabled }: { id: string; enabled: boolean }) {
  return {
    url: `${endpointUrl}/${id}/enabled`,
    method: 'PATCH',
    body: { enabled }
  };
}

function toggleUserEnabled({ id, enabled }: { id: string; enabled: boolean }) {
  return {
    url: `${endpointUrl}/${id}/enabled`,
    method: 'PATCH',
    body: { enabled }
  };
}

function updateAgency({ id, agency }: { id: string; agency: string }) {
  return {
    url: `${endpointUrl}/${id}/agency`,
    method: 'PATCH',
    body: { agency }
  };
}

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getAllUsers: query<User[], void>({
      query: getUsers,
      providesTags: ['Users']
    }),
    getUser: query<User, { id: string }>({
      query: getUser
    }),
    blockUser: mutation<void, { id: string; enabled: boolean }>({
      query: blockUser,
      invalidatesTags: ['Users']
    }),
    toggleUserEnabled: mutation<void, { id: string; enabled: boolean }>({
      query: toggleUserEnabled,
      invalidatesTags: ['Users']
    }),
    updateAgency: mutation<void, { id: string; agency: string }>({
      query: updateAgency,
      invalidatesTags: ['Users']
    }),
    updatePassword: mutation<void, { id: string; value: string }>({
      query: updatePassword
    }),
    deleteUser: mutation<void, { id: string }>({
      query: deleteUser,
      invalidatesTags: ['Users']
    }),
    createUser: mutation<
      void,
      {
        userName: string;
        firstName: string;
        lastName: string;
        group: 'admin' | 'department' | 'recruiter' | 'operation';
        agency: string;
        temporaryPassword: string;
        emailVerified?: boolean;
      }
    >({
      query: createUser,
      invalidatesTags: ['Users']
    })
  })
});

export const {
  useGetAllUsersQuery,
  useGetUserQuery,
  useBlockUserMutation,
  useToggleUserEnabledMutation,
  useUpdatePasswordMutation,
  useDeleteUserMutation,
  useUpdateAgencyMutation,
  useCreateUserMutation
} = userApiSlice;

export default userApiSlice;
